'use strict';

var _createForOfIteratorHelper = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _awaitAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var errcode = require('err-code');

var pTimeout = require('p-timeout');

var PeerInfo = require('peer-info');

var c = require('../constants');

var LimitedPeerList = require('../peer-list/limited-peer-list');

var Message = require('../message');

var Query = require('../query');

var utils = require('../utils');

module.exports = function (dht) {
  /**
   * Check for providers from a single node.
   *
   * @param {PeerId} peer
   * @param {CID} key
   * @returns {Promise<Message>}
   *
   * @private
   */
  var findProvidersSingle = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(peer, key) {
      var msg;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // eslint-disable-line require-await
              msg = new Message(Message.TYPES.GET_PROVIDERS, key.buffer, 0);
              return _context.abrupt("return", dht.network.sendRequest(peer, msg));

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function findProvidersSingle(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  return {
    /**
     * Announce to the network that we can provide given key's value.
     * @param {CID} key
     * @returns {Promise<void>}
     */
    provide: function provide(key) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var errors, msg, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, peer;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                dht._log('provide: %s', key.toBaseEncodedString());

                errors = []; // Add peer as provider

                _context2.next = 4;
                return dht.providers.addProvider(key, dht.peerInfo.id);

              case 4:
                msg = new Message(Message.TYPES.ADD_PROVIDER, key.buffer, 0);
                msg.providerPeers = [dht.peerInfo]; // Notify closest peers

                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _context2.prev = 8;
                _iterator = _asyncIterator(dht.getClosestPeers(key.buffer));

              case 10:
                _context2.next = 12;
                return _iterator.next();

              case 12:
                _step = _context2.sent;
                _iteratorNormalCompletion = _step.done;
                _context2.next = 16;
                return _step.value;

              case 16:
                _value = _context2.sent;

                if (_iteratorNormalCompletion) {
                  _context2.next = 31;
                  break;
                }

                peer = _value;

                dht._log('putProvider %s to %s', key.toBaseEncodedString(), peer.toB58String());

                _context2.prev = 20;
                _context2.next = 23;
                return dht.network.sendMessage(peer, msg);

              case 23:
                _context2.next = 28;
                break;

              case 25:
                _context2.prev = 25;
                _context2.t0 = _context2["catch"](20);
                errors.push(_context2.t0);

              case 28:
                _iteratorNormalCompletion = true;
                _context2.next = 10;
                break;

              case 31:
                _context2.next = 37;
                break;

              case 33:
                _context2.prev = 33;
                _context2.t1 = _context2["catch"](8);
                _didIteratorError = true;
                _iteratorError = _context2.t1;

              case 37:
                _context2.prev = 37;
                _context2.prev = 38;

                if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                  _context2.next = 42;
                  break;
                }

                _context2.next = 42;
                return _iterator.return();

              case 42:
                _context2.prev = 42;

                if (!_didIteratorError) {
                  _context2.next = 45;
                  break;
                }

                throw _iteratorError;

              case 45:
                return _context2.finish(42);

              case 46:
                return _context2.finish(37);

              case 47:
                if (!errors.length) {
                  _context2.next = 49;
                  break;
                }

                throw errcode("Failed to provide to ".concat(errors.length, " of ").concat(dht.kBucketSize, " peers"), 'ERR_SOME_PROVIDES_FAILED', {
                  errors: errors
                });

              case 49:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[8, 33, 37, 47], [20, 25], [38,, 42, 46]]);
      }))();
    },

    /**
     * Search the dht for up to `K` providers of the given CID.
     * @param {CID} key
     * @param {Object} options - findProviders options
     * @param {number} options.timeout - how long the query should maximally run, in milliseconds (default: 60000)
     * @param {number} options.maxNumProviders - maximum number of providers to find
     * @returns {AsyncIterable<PeerInfo>}
     */
    findProviders: function findProviders(key) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var providerTimeout, n, out, provs, _iterator2, _step2, pInfo, paths, query, peers, _iterator3, _step3, _pInfo;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                providerTimeout = options.timeout || c.minute;
                n = options.maxNumProviders || c.K;

                dht._log('findProviders %s', key.toBaseEncodedString());

                out = new LimitedPeerList(n);
                _context4.next = 6;
                return _awaitAsyncGenerator(dht.providers.getProviders(key));

              case 6:
                provs = _context4.sent;
                provs.forEach(function (id) {
                  var info;

                  if (dht.peerStore.has(id)) {
                    info = dht.peerStore.get(id);
                  } else {
                    info = dht.peerStore.put(new PeerInfo(id));
                  }

                  out.push(info);
                }); // All done

                if (!(out.length >= n)) {
                  _context4.next = 27;
                  break;
                }

                // yield values
                _iterator2 = _createForOfIteratorHelper(out.toArray());
                _context4.prev = 10;

                _iterator2.s();

              case 12:
                if ((_step2 = _iterator2.n()).done) {
                  _context4.next = 18;
                  break;
                }

                pInfo = _step2.value;
                _context4.next = 16;
                return pInfo;

              case 16:
                _context4.next = 12;
                break;

              case 18:
                _context4.next = 23;
                break;

              case 20:
                _context4.prev = 20;
                _context4.t0 = _context4["catch"](10);

                _iterator2.e(_context4.t0);

              case 23:
                _context4.prev = 23;

                _iterator2.f();

                return _context4.finish(23);

              case 26:
                return _context4.abrupt("return");

              case 27:
                // need more, query the network
                paths = [];
                query = new Query(dht, key.buffer, function (pathIndex, numPaths) {
                  // This function body runs once per disjoint path
                  var pathSize = utils.pathSize(n - out.length, numPaths);
                  var pathProviders = new LimitedPeerList(pathSize);
                  paths.push(pathProviders); // Here we return the query function to use on this particular disjoint path

                  return /*#__PURE__*/function () {
                    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(peer) {
                      var msg, provs;
                      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                        while (1) {
                          switch (_context3.prev = _context3.next) {
                            case 0:
                              _context3.next = 2;
                              return findProvidersSingle(peer, key);

                            case 2:
                              msg = _context3.sent;
                              provs = msg.providerPeers;

                              dht._log('(%s) found %s provider entries', dht.peerInfo.id.toB58String(), provs.length);

                              provs.forEach(function (prov) {
                                pathProviders.push(dht.peerStore.put(prov));
                              }); // hooray we have all that we want

                              if (!(pathProviders.length >= pathSize)) {
                                _context3.next = 8;
                                break;
                              }

                              return _context3.abrupt("return", {
                                pathComplete: true
                              });

                            case 8:
                              return _context3.abrupt("return", {
                                closerPeers: msg.closerPeers
                              });

                            case 9:
                            case "end":
                              return _context3.stop();
                          }
                        }
                      }, _callee3);
                    }));

                    return function (_x3) {
                      return _ref2.apply(this, arguments);
                    };
                  }();
                });
                peers = dht.routingTable.closestPeers(key.buffer, dht.kBucketSize);
                _context4.prev = 30;
                _context4.next = 33;
                return _awaitAsyncGenerator(pTimeout(query.run(peers), providerTimeout));

              case 33:
                _context4.next = 39;
                break;

              case 35:
                _context4.prev = 35;
                _context4.t1 = _context4["catch"](30);

                if (!(_context4.t1.name !== pTimeout.TimeoutError.name)) {
                  _context4.next = 39;
                  break;
                }

                throw _context4.t1;

              case 39:
                _context4.prev = 39;
                query.stop();
                return _context4.finish(39);

              case 42:
                // combine peers from each path
                paths.forEach(function (path) {
                  path.toArray().forEach(function (peer) {
                    out.push(peer);
                  });
                });

                if (!(out.length === 0)) {
                  _context4.next = 45;
                  break;
                }

                throw errcode(new Error('no providers found'), 'ERR_NOT_FOUND');

              case 45:
                _iterator3 = _createForOfIteratorHelper(out.toArray());
                _context4.prev = 46;

                _iterator3.s();

              case 48:
                if ((_step3 = _iterator3.n()).done) {
                  _context4.next = 54;
                  break;
                }

                _pInfo = _step3.value;
                _context4.next = 52;
                return _pInfo;

              case 52:
                _context4.next = 48;
                break;

              case 54:
                _context4.next = 59;
                break;

              case 56:
                _context4.prev = 56;
                _context4.t2 = _context4["catch"](46);

                _iterator3.e(_context4.t2);

              case 59:
                _context4.prev = 59;

                _iterator3.f();

                return _context4.finish(59);

              case 62:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[10, 20, 23, 26], [30, 35, 39, 42], [46, 56, 59, 62]]);
      }))();
    }
  };
};